export function shipmentCommentUploadValidate(shipment){
    var result = true;

    result = validateMessage(shipment.message);

    return result;
}

function validateMessage(message) {
    if(typeof message === 'string' && message.trim() !== '' && message == "shipment_comments.success") return true;
    else return false;
}